// @TODO <HEALTH2019>
App.controller('ZochHealthInsuranceListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', '$filter', '$rootScope', 'zochaHealthInsuranceService', 'zochaNavigationService', 'popUpService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver, $filter, $rootScope, zochaHealthInsuranceService, zochaNavigationService, popUpService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    console.log($scope.stateParams.user);
    if ($scope.stateParams.user) {
        $scope.userId = $scope.stateParams.user.id;
        $scope.who = $scope.stateParams.user.person.firstName + ' ' + $scope.stateParams.user.person.lastName;
    } else {
        $scope.userId = '';
        $scope.who = '';
    }

    $scope.step = 'Zarządzaj deklaracjami - Ubezpieczenie zdrowotne';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.dictionary = {
        "ENTERED": "wprowadzony",
        "EXPIRED": "wygaszony",
        "DELETED": "usunięty",
        "READY": "zawarty",
        "ACTIVE": "aktywny",
        "CANCELED": "anulowany",
        "WITHDRAWN": "wystąpienie",
        "ENDED": "zakończony"
    };

    let page = 0;
    $scope.status = 'all';
    $scope.current = page;
    $scope.pageSize = 10;
    $scope.searchString = '';

    loadActivities(page);

    $scope.search = function () {
        loadActivities(0, $scope.status);
    };

    $scope.byStatus = function (status) {
        loadActivities(0, status);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page, $scope.status);
        $scope.current = page;
    };

    $scope.loadAll = function () {
        $scope.userId = '';
        $scope.who = '';
        $scope.status = 'all';
        $scope.current = 0;
        $scope.searchString = '';
        loadActivities(0, 'all');
    };

    function loadActivities(page, status) {
        let criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize,
            userId: $scope.userId,
            search: $scope.searchString,
            insurer: 'TUZ'
        };

        if ($scope.cantDeduct) {
            criteria.cantDeduct = $scope.cantDeduct;
        }

        console.log(status);

        if (status && status !== 'all') {
            criteria.status = status;
        }

        zochaHealthInsuranceService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.activities = data.data.data;
                if ($scope.activities) {
                    for (let a = 0; a < $scope.activities.length; a++) {
                        $scope.activities[a].activeStatus = $scope.activities[a].status === 'ACTIVE';
                        if ($scope.activities[a].rehabilitation) {
                            $scope.activities[a].benefit.name += ' + Rehabilitacja';
                            $scope.activities[a].benefit.summaryPrice += $scope.activities[a].benefit.rehabilitationPrice;
                        }
                    }
                }
                $scope.numberOfPages = data.data.pages;
                console.log($scope.activities);
            }
        });
    }

    $scope.changeStatus = function (id, value) {
        if (value) {
            zochaInsuranceService.originalCopyEntered(id).then(function (data) {
                if (data.status === 200) {
                    loadActivities($scope.current);
                }
            });
        }
    };

    $scope.active = function (id, value) {
        if (value) {
            zochaInsuranceService.active(id).then(function (data) {
                if (data.status === 200) {
                    loadActivities($scope.current);
                }
            });
        }
    };

    $scope.getDeclaration = function (value) {
        let id = value.id, barcode = value.barcode;
        zochaInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                let blobData = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(blobData, 'Deklaracja_' + barcode + '.pdf');
            }
        });
    };

    $scope.uploadDeclaration = function (id) {
        let vm = this;

        if (!vm.uploadDeclarationForm.$valid) {
            return 0;
        }

        zochaHealthInsuranceService.enterOriginalCopyBarcode(id).then(function (data) {
            console.log(data);
            if (data.status === 200) {
                if (!data.data.replacedDeclaration) {
                    $scope.showPopUp('', '', 'Dostarczenie dokumentu nr ' + id + ' zostało oznaczone poprawnie w systemie', '', '', true);
                } else {
                    $scope.showPopUp('', '', 'Dostarczony dokument nr ' + id + ' zastępuje w systemie dokument nr ' + data.data.replacedDeclaration.barcode + '. Zmiany będą obowiązywać od ' + $filter('dateFormatter')(data.data.replacedDeclaration.endDateBasedOnWithdrawalDate), '', '', true);
                }
            } else if (data.data.message === 'DeclatrationNotExistsException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: '', content: 'W systemie nie istnieje podany numer deklaracji. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', text: '', target: '', reload: false});
            } else if (data.data.message === 'OriginalCopyAlreadyEnteredException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: '', content: 'W systemie jest już oznaczone dostarczenie oryginału dokumentu.', text: '', target: '', reload: false});
            } else if (data.data.message === 'WrongStatusException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: '', content: 'Wskazana deklaracja jest nieaktywna! Nie można jej już aktywować. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', text: '', target: '', reload: false});
            }
        });
    };

    $scope.showPopUp = function (ev, head, content, text, target, reload) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                reload: reload,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals, $state) {
        $scope.locals = locals;

        $scope.hide = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.buildScroll = function () {
        $timeout(function () {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    };

    $scope.cantDeduct = false;

    $scope.filterCantDeduct = function () {
        loadActivities(0, $scope.status);
    };

    $scope.goToWorkerDetails = function (value) {
        zochaNavigationService.goToWorkerDetails(value.userId);
    };

    $scope.goToDeclarationDetails = function (value) {
        $state.go('root.home.zoch.healthInsurance.details', {package: value});
    };

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis: "x",
            theme: "dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced: {autoExpandHorizontalScroll: true},
            callbacks: {
                onInit: function () {

                },
                onScroll: function () {

                }
            }
        });
    }
}]);
